import { useTranslation } from 'react-i18next'

import { useProfilePreferenceActions } from '../../../../../hooks/profile/useProfilePreferenceActions'

import FormSection from '../../../../formSection/FormSection'
import { SelectOptionInput } from '../../../../input/selectOptionInput/SelectOptionInput'

import { Language } from '../../../../../types/language'
import { ThemeType } from '../../../../../types/contexts/AppContext'

const PreferencesForm = () => {
  const { t } = useTranslation('account')
  const {
    theme,
    language,
    loading,
    changeTheme,
    changeLanguage,
  } = useProfilePreferenceActions()

  const languageOptions = Object.values(Language).map(language => ({
    value: language,
    label: t(`account.preferences.language.${language.toLowerCase()}`),
  }))

  const themeOptions = Object.values(ThemeType).map(theme => ({
    value: theme,
    label: t(`account.preferences.theme.${theme}`),
  }))

  return (
    <FormSection title={t('account.preferences.title')}>
      <div className="row g-3">
        <div className="col-12">
          <SelectOptionInput
            name="language"
            label={t('account.preferences.language')}
            value={language}
            list={languageOptions}
            disabled={loading}
            required
            onChange={(_, value) => {
              void changeLanguage(value as Language)
            }}
          />
        </div>
        <div className="col-12">
          <SelectOptionInput
            name="theme"
            label={t('account.preferences.theme')}
            value={theme}
            list={themeOptions}
            disabled={loading}
            required
            onChange={(_, value) => {
              void changeTheme(value as ThemeType)
            }}
          />
        </div>
      </div>
    </FormSection>
  )
}

export default PreferencesForm
